import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const GeneralLedgerFilters = ({
  searchTerm,
  onSearchChange,
  accountFilter,
  onAccountChange,
  accountOptions,
  dateRange,
  onDateRangeChange,
  transactionTypeFilter,
  onTransactionTypeChange
}) => {
  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' },
    { value: 'quarter', label: 'Last 90 Days' },
    { value: 'year', label: 'Last Year' }
  ];

  const transactionTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'Invoice', label: 'Invoice' },
    { value: 'Invoice Payment', label: 'Invoice Payment' },
    { value: 'Expense', label: 'Expense' },
    { value: 'Journal Entry', label: 'Journal Entry' },
    { value: 'Payroll', label: 'Payroll' },
    { value: 'Bank Transaction', label: 'Bank Transaction' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="relative">
          <Icon
            name="Search"
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <Input
            placeholder="Search transactions..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-10"
          />
        </div>

        <Select
          options={accountOptions}
          value={accountFilter}
          onChange={onAccountChange}
          placeholder="Filter by account"
          searchable
        />

        <Select
          options={dateRangeOptions}
          value={dateRange}
          onChange={onDateRangeChange}
          placeholder="Filter by date"
        />

        <Select
          options={transactionTypeOptions}
          value={transactionTypeFilter}
          onChange={onTransactionTypeChange}
          placeholder="Filter by type"
        />
      </div>
    </div>
  );
};

export default GeneralLedgerFilters;